import {useState} from "react";
import wrongAnswer from "../assets/images/wrong-icon.svg";
import correctAnswer from "../assets/images/correct.svg";

function QuizMatchIt({question}) {
    const [qst, setQst] = useState(question)
    const [selected, setSelected] = useState(null)
    const [message, setMessage] = useState(null)
    const [clearTimer, setClearTimer] = useState(null)

    const handle = {
        drag: {
            element: null,
            over: e => {
                e.stopPropagation()
                e.preventDefault()
            },
            drop: e => handle.drag.element = e.currentTarget,
            end: e => {
                const el = handle.drag.element
                handle.drag.element = null
                if (clearTimer) return
                if (!el.classList.contains("holder")) return
                const correct = e.currentTarget.id === el.id
                const dragged = qst.answers.find(a => a.id === parseInt(e.currentTarget.id))
                const na = qst.answers.map(a => a === dragged ? {...a, used: true, correct } : a)
                const nh = qst.holders.map(h => h.id === parseInt(el.id) ? {...h, holding: dragged, correct} : h)
                setQst({...qst, holders: nh, answers: na})
                setSelected({correct})
                setMessage(correct)
                setClearTimer(setTimeout(() => {
                    setClearTimer(null)
                    setMessage(null)
                    if (!correct) setQst({...qst, holders: qst.holders, answers: qst.answers})
                }, 3000))
            }
        }
    }

    return (
        <div className={"quiz-match-it drag-and-drop"}>
            <h2>Drag & drop the correct english meaning in each box.</h2>
            <div className={"quiz-message"}>
            {
                selected === null || message === null ? ""
                    : selected.correct ? <div className={"correct"}><span><img src={correctAnswer} alt={"correct Answer"} /><span>Correct answer. Good job!</span></span></div>
                        : <div className={"wrong"}><span><img src={wrongAnswer} alt={"wrong Answer"} /><span>Incorrect answer. Try again!</span></span></div>
            }
            </div>
            <div className={"question-panel"}>
                <div className={"question"}>
                    {
                        qst.holders.map(q =>
                            <div key={q.id}>
                                <div className={"question-title"}>{ q.text.ch }</div>
                                <div id={q.id} className={`holder ${q.hasOwnProperty("correct") ? q.correct ? "correct" : "wrong" : ""}`} onDragOver={handle.drag.over} onDrop={handle.drag.drop}>
                                    { q.holding && <span>{ q.holding.text.en }</span> }
                                </div>
                            </div>)
                    }
                </div>
                <ul className={"answers"}>
                    { qst.answers.map(q => <li key={q.id} id={q.id}
                                                    draggable={!q.used}
                                                    className={`${q.used ? "used" : ""} ${q.hasOwnProperty("correct") ? q.correct ? "correct" : "wrong" : ""}`}
                                                    onDragEnd={handle.drag.end}>{q.text.en}</li>) }
                </ul>
            </div>
        </div>
    )
}

export default QuizMatchIt